import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard.component';
import { MenuComponent } from './menu/menu.component';
import { PersonDetailComponent } from './persons/person-detail.component';
import { PersonResponsesComponent } from './persons/person-responses.component';
import { BooleanPipe } from './pipes/boolean.pipe';
import { GoDatePipe } from './pipes/godate.pipe';
import { HumanIntervalPipe } from './pipes/human-interval.pipe';
import { SecsPipe } from './pipes/secs.pipe';
import { SmallTimePipe } from './pipes/smalltime.pipe';
import { TimePipe } from './pipes/time.pipe';
import { ProfileDetailComponent } from './profiles/profile-detail.component';
import { ProfilesComponent } from './profiles/profiles.component';
import { ProgrammeDetailComponent } from './programmes/programme-detail.component';
import { ProgrammeResponsesComponent } from './programmes/programme-responses.component';
import { ProgrammesComponent } from './programmes/programmes.component';
import { VoxResponsePlayerComponent } from './responses/response-player.component';
import { ResponsesComponent } from './responses/responses.component';
import { ApiService } from './services/api.service';
import { ProfileService } from './services/profile.service';
import { TokenInterceptor } from './services/token.interceptor.service';
import { VoxPopService } from './services/voxpop.service';
import { TopicDetailComponent } from './topics/topic-detail.component';
import { TopicResponsesComponent } from './topics/topic-responses.component';
import { TopicsComponent } from './topics/topics.component';
import { CheckboxComponent } from './widgets/checkbox.component';
import { VoxBtn } from './widgets/voxbtn';

@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    DashboardComponent,
    TopicsComponent,
    ProgrammesComponent,
    TopicDetailComponent,
    ResponsesComponent,
    TopicResponsesComponent,
    ProgrammeResponsesComponent,
    ProgrammeDetailComponent,
    VoxResponsePlayerComponent,
    PersonResponsesComponent,
    PersonDetailComponent,
    ProfilesComponent,
    ProfileDetailComponent,
    BooleanPipe,
    GoDatePipe,
    SmallTimePipe,
    SecsPipe,
    HumanIntervalPipe,
    TimePipe,
    CheckboxComponent,
    VoxBtn,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatInputModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    ApiService,
    VoxPopService,
    ProfileService,
    { provide: 'Window', useValue: window },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})


export class AppModule {
}
